module.exports = __webpack_public_path__ + "img/2-4.a860dc16.svg";